module.exports = __webpack_public_path__ + "img/banner.7977f3bd.jpg";